import notSupportedOperatorsByField from '@/Core/config/not-supported-operators-by-field';
import { DatetimeQueryBuilder } from '@/Core/utilities/filter-query-builders/DatetimeQueryBuilder';

const getOperatorsByField = fieldName => {
    if (!notSupportedOperatorsByField[fieldName]) return DatetimeQueryBuilder.OperatorList;

    return DatetimeQueryBuilder.OperatorList.filter(operator => {
        return !notSupportedOperatorsByField[fieldName].includes(operator.name)
    });
};

export default getOperatorsByField;
